import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-53adfe7c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "space-success-container"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "space-success-title"
  }, " 恭喜你，空间创建成功 ", -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "space-success-bizId-title"
  }, " 空间名称 ", -1);
});

var _hoisted_4 = {
  class: "space-success-bizId"
};
var _hoisted_5 = {
  class: "space-success-bizUrl-container"
};
var _hoisted_6 = {
  class: "space-success-bizUrl"
};
import { ref } from 'vue';
export default {
  props: {
    // 新创建的空间信息（包含空间名称和空间id）
    spaceInfo: {
      type: Object,
      default: function _default() {
        return {
          bizId: '',
          bizName: '',
          bizUrl: ''
        };
      }
    }
  },
  emits: ['entry-space'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var hostName = ref("".concat(location.origin, "/"));

    var enterSpace = function enterSpace() {
      var _props$spaceInfo$valu = props.spaceInfo.value,
          bizId = _props$spaceInfo$valu.bizId,
          bizName = _props$spaceInfo$valu.bizName,
          bizUrl = _props$spaceInfo$valu.bizUrl;
      emit('entry-space', bizId, bizName, bizUrl);
    };

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(__props.spaceInfo.value.bizName), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, " 专属域名：" + _toDisplayString(hostName.value) + _toDisplayString(__props.spaceInfo.value.bizId), 1)]), _createElementVNode("button", {
        class: "btn-button",
        onClick: enterSpace
      }, " 进入空间 ")]);
    };
  }
};